import axios from 'axios'
import moment from 'moment'
import store from '../../../store'
import features from './features'

const setList = ({ commit }, payload) => {
  if (payload.doctor === null) return
  const period = moment(payload.date, 'YYYY-MM-DD').format('MM/DD/YYYY')
  return new Promise((resolve, reject) => {
    commit('SET_LIST', [])
    commit('SET_APPOINTMENTS', [])
    axios.get(`${process.env.URL}/my-clinic-new/schedule-sync/appointments`, {
      params: {
        customer: payload.customer,
        doctor: payload.doctor,
        period: period
      }
    })
      .then(function (response) {
        // handle success
        const items = []
        const items2 = []

        if (response.data && response.data.results && response.data.results.results) {
          response.data.results.results.map((item) => {
            if ((item.tbTipo === 'C')) {
              items2.push({
                id: item.id,
                icon: 'notifications',
                iconClass: 'orange lighten-1 white--text',
                title: item.name || `Compromissos`,
                subtitle: item.tbHora ? item.tbHora.substring(0, 5) : item.hour ? item.hour.substring(11, 16) : '00:00',
                type: 'Compromisso',
                interval: item.interval
              })
            }
            items.push({
              id: item.tbID || item.id,
              convenant: item.tbCodConv || item.healthInsuranceCode,
              convenantDesc: item.tbConvenio || item.healthInsuranceDescription,
              descType: item.tbDescTipoCons || item.typeDescription,
              icon: features.typeStatusIcons(item.tbTipo || item.type, item.statusCode || item.tbStatus),
              iconClass: features.iconClass(item.tbTipo || item.type, item.statusCode || item.tbStatus),
              title: item.tbNome || item.name || `Vago`,
              subtitle: item.tbHora ? item.tbHora.substring(0, 5) : item.hour ? item.hour.substring(11, 16) : '00:00',
              type: features.typeProcedure(item.tbTipo || item.type),
              typeDesc: item.tbTipoDesc || item.typeDescription,
              mobile: item.tbCelular || item.mobile,
              typeAppontement: item.tbTipoAgendamento || item.typeSchedule,
              email: item.tbEmail || item.email,
              interval: item.tbIntervalo || item.interval,
              doctor: payload.doctor,
              period: period,
              code: item.tbFicha || item.record
            })
          })
        }
        commit('SET_LIST', items)
        commit('SET_APPOINTMENTS', items2)
        resolve()
      })
      .catch(function (error) {
        // handle error
        console.error('err', error)
        reject(error)
      })
      .then(function () {
        // always executed
      })
  })
}

const setAppointmentsSurgerycenter = ({ commit }, payload) => {
  if (payload.doctor === null) return
  const period = moment(payload.date, 'YYYY-MM-DD').format('MM/DD/YYYY')
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.URL}/my-clinic-new/schedule-sync/appointments-surgery-center`, {
      params: {
        customer: store.state.customer,
        doctor: payload.doctor,
        period: period
      }
    })
      .then(function (response) {
        const items3 = []

        if (response.data && response.data.results && response.data.results.results) {
          response.data.results.results.map((item) => {
            items3.push({
              id: item.tbNumSaidaSala,
              icon: 'add',
              iconClass: 'red lighten-1 white--text',
              title: item.tbNome || `Cirurgia`,
              subtitle: moment(item.tbData, 'YYYY-MM-DD').format('DD/MM/YYYY'),
              type: 'Cirurgia',
              interval: item.tbNumSaidaSala
            })
          })
        }
        return resolve(commit('SET_APPOINTMENTSSURGERYCENTER', items3))
      })
      .catch(function (error) {
        console.error('err', error)
        reject(error)
      })
  })
}

const setAvailableAppointments = ({ commit }, schedule) => {
  commit('SET_AVAILABLEAPPOINTMENTS', schedule)
}

const setProposedSurgeries = ({ commit }, payload) => {
  if (!payload.customer) return
  const period = moment(payload.date, 'YYYY-MM-DD').format('MM/DD/YYYY')
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.URL}/my-clinic-new/schedule-sync/proposed-surgeries`, {
      params: {
        customer: payload.customer,
        doctor: payload.doctor,
        period: period
      }
    })
      .then(function (response) {
        // handle success
        const items = []
        if (response.data && response.data.results && response.data.results.results) {
          response.data.results.results.map((item) => {
            items.push({
              id: item.tbKeyReg,
              action: moment(item.tbDataHoraCirurgia, 'YYYY-MM-DD').format('DD/MM/YYYY') || '00:00',
              headline: item.tbDescStatus || 'Sem Status',
              title: item.tbNomePaciente,
              subtitle: item.tbDesc_Cirurgia
            })
          })
        }
        commit('SET_PROPOSEDSURGERIES', items)
        resolve()
      })
      .catch(function (error) {
        // handle error
        console.error('err', error)
        reject(error)
      })
      .then(function () {
        // always executed
      })
  })
}

const setLockAppointments = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios.post(`${process.env.URL}/my-clinic-new/schedule-sync/lock`, {
      period: payload.period,
      hour: payload.subtitle,
      doctor: payload.doctor
    }, {
      params: {
        customer: store.state.customer
      }
    })
      .then(function (response) {
        resolve()
      })
      .catch(function (error) {
        // handle error
        console.error('err', error)
        reject(error)
      })
      .then(function () {
        // always executed
      })
  })
}

const setUnLockAppointments = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    axios.post(`${process.env.URL}/my-clinic-new/schedule-sync/un-lock`, {
      period: payload.period,
      hour: payload.subtitle,
      doctor: payload.doctor
    }, {
      params: {
        customer: store.state.customer
      }
    })
      .then(function (response) {
        resolve()
      })
      .catch(function (error) {
        // handle error
        console.error('err', error)
        reject(error)
      })
      .then(function () {
        // always executed
      })
  })
}

const setSurgeries = ({ commit }, payload) => {
  if (!store.state.customer) return
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.URL}/my-clinic-new/schedule-sync/surgeries`, {
      params: {
        customer: store.state.customer
      }
    })
      .then(function (response) {
        if (response.data && response.data.results && response.data.results.results) {
          const items = response.data.results.results.map((item) => {
            if (item.type === 'cirurgia') return item
          })
          const filter = items.filter((item) => {
            return item != null
          })
          commit('SET_SURGERIES', filter)
          const items2 = response.data.results.results.map((item) => {
            if (item.type !== 'cirurgia') return item
          })
          const filter2 = items2.filter((item) => {
            return item != null
          })
          commit('SET_ANESTHESIA', filter2)
        }
      })
      .catch(function (error) {
        // handle error
        console.error('err', error)
        reject(error)
      })
      .then(function () {
        // always executed
      })
  })
}

const setCreateProposedSurgeries = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const config = {
      params: {
        customer: store.state.customer
      }
    }
    axios.post(`${process.env.URL}/my-clinic-new/schedule-sync/proposed-surgeries`, payload, config)
      .then(function (response) {
        console.dir(response)
      })
      .catch(function (error) {
        // handle error
        console.error('err', error)
        reject(error)
      })
      .then(function () {
        // always executed
      })
  })
}

export default {
  setSurgeries,
  setList,
  setLockAppointments,
  setUnLockAppointments,
  setAvailableAppointments,
  setAppointmentsSurgerycenter,
  setProposedSurgeries,
  setCreateProposedSurgeries
}



// WEBPACK FOOTER //
// ./src/store/modules/schedule/actions.js